export const WOBBLE_ANGLE = 5;
export const SPEED = 3;
